
export type TrendItemBasicInfoAllOfTwoCategory = typeof TrendItemBasicInfoAllOfTwoCategory[keyof typeof TrendItemBasicInfoAllOfTwoCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrendItemBasicInfoAllOfTwoCategory = {
  TOPIC: 'TOPIC',
  TWEET: 'TWEET',
  USER: 'USER',
  PROJECT: 'PROJECT',
} as const;
